import { render, staticRenderFns } from "./ContactDetailForm.vue?vue&type=template&id=32c317ae"
import script from "./ContactDetailForm.vue?vue&type=script&lang=js"
export * from "./ContactDetailForm.vue?vue&type=script&lang=js"
import style0 from "./ContactDetailForm.vue?vue&type=style&index=0&id=32c317ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports